app.controller('CallToActionRegistrationSessionController', function($scope, callToActionRegistrationSessionService) {
    $scope.callToActionRegistration = { 
        callToActionRegistrationSession: callToActionRegistrationSessionService
    };
});
